import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "b9bdef81-78eb-4110-98be-39ecfee0f218",
    content: "The translation and rotation of the Source<br>are essential for the receiver directivity.",
    options: {},
  },
  {
    id: "a6ae3af8-5f7d-4ce1-865a-54ffacaf432b",
    content: "All parts of the acoustical simulation need<br>to be updated if the source rotation changes.",
    options: {},
  },
  {
    id: "b93fca9e-8ac9-413d-8c18-1a3e97c5f45a",
    content: "The filters have to be reconstructed<br>if the source rotation changes.",
    options: {},
  },
  {
    id: "affc16bf-6c1b-4ba5-bd1b-4033b7c05171",
    content:
      "The final filter includes directional and<br>geometrical information, such as room<br>reflections and reverberation.",
    options: {},
  },
  {
    id: "2b86c86d-948b-4ec2-bdc4-65cf3d0a0e61",
    content: "For the simulation and filter construction,<br>audio and directivity databases are needed.",
    options: {},
  },
  {
    id: "f229d0a8-01d4-44d3-97d5-4de1c79e1fef",
    content:
      "The latency of the simulation need to be lower<br>than 50 ms, otherwise delays and/or mismatch<br>between sound and visuals might be noticed.",
    options: {},
  },
];

export const task: Task = {
  id: "50de8fee-9e27-4114-8e6e-ed82b976f02e",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "b93fca9e-8ac9-413d-8c18-1a3e97c5f45a",
    "affc16bf-6c1b-4ba5-bd1b-4033b7c05171",
    "2b86c86d-948b-4ec2-bdc4-65cf3d0a0e61",
    "f229d0a8-01d4-44d3-97d5-4de1c79e1fef",
  ],
};
